import { ArrowsClockwise, FunnelSimple } from "@phosphor-icons/react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function FilterBar({ filters, options, onChange, onReset }) {
    const set = (k, v) => onChange({ ...filters, [k]: v });
    return (
        <div className="reedos-card p-4" data-testid="pipeline-filters">
            <div className="flex items-center justify-between mb-3">
                <div className="reedos-eyebrow flex items-center gap-1.5"><FunnelSimple size={11} /> Filters</div>
                <Button variant="ghost" size="sm" onClick={onReset} className="text-[11px] gap-1 text-slate-500 hover:text-slate-900" data-testid="pipeline-filters-reset">
                    <ArrowsClockwise size={11} /> Reset
                </Button>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
                <div>
                    <Label className="text-[10px] font-semibold text-slate-500 uppercase">From</Label>
                    <Input type="date" value={filters.date_from || ""} onChange={(e) => set("date_from", e.target.value)} className="mt-1 h-8 text-xs" data-testid="pipeline-filter-date-from" />
                </div>
                <div>
                    <Label className="text-[10px] font-semibold text-slate-500 uppercase">To</Label>
                    <Input type="date" value={filters.date_to || ""} onChange={(e) => set("date_to", e.target.value)} className="mt-1 h-8 text-xs" data-testid="pipeline-filter-date-to" />
                </div>
                <div>
                    <Label className="text-[10px] font-semibold text-slate-500 uppercase">Sales rep</Label>
                    <select value={filters.sales_rep || ""} onChange={(e) => set("sales_rep", e.target.value)} className="mt-1 w-full h-8 px-2 text-xs border border-slate-200 rounded bg-white" data-testid="pipeline-filter-sales-rep">
                        <option value="">All reps</option>
                        {options.sales_reps?.map((r) => (
                            <option key={r.id} value={r.id}>{r.name}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <Label className="text-[10px] font-semibold text-slate-500 uppercase">State</Label>
                    <select value={filters.state_code || ""} onChange={(e) => set("state_code", e.target.value)} className="mt-1 w-full h-8 px-2 text-xs border border-slate-200 rounded bg-white" data-testid="pipeline-filter-state">
                        <option value="">All states</option>
                        {options.states?.map((s) => (
                            <option key={s} value={s}>{s}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <Label className="text-[10px] font-semibold text-slate-500 uppercase">Segment</Label>
                    <select value={filters.segment || ""} onChange={(e) => set("segment", e.target.value)} className="mt-1 w-full h-8 px-2 text-xs border border-slate-200 rounded bg-white" data-testid="pipeline-filter-segment">
                        <option value="">All segments</option>
                        {options.segments?.map((s) => (
                            <option key={s} value={s}>{s}</option>
                        ))}
                        {(!options.segments || options.segments.length === 0) && <option disabled>None tagged yet</option>}
                    </select>
                </div>
                <div>
                    <Label className="text-[10px] font-semibold text-slate-500 uppercase">GST Type</Label>
                    <select value={filters.gst_type || ""} onChange={(e) => set("gst_type", e.target.value)} className="mt-1 w-full h-8 px-2 text-xs border border-slate-200 rounded bg-white" data-testid="pipeline-filter-gst-type">
                        <option value="">All</option>
                        {options.gst_types?.map((g) => (
                            <option key={g} value={g}>{g}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <Label className="text-[10px] font-semibold text-slate-500 uppercase">Module</Label>
                    <select value={filters.module_code || ""} onChange={(e) => set("module_code", e.target.value)} className="mt-1 w-full h-8 px-2 text-xs border border-slate-200 rounded bg-white" data-testid="pipeline-filter-module">
                        <option value="">All modules</option>
                        {options.modules?.map((m) => (
                            <option key={m} value={m}>{m}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}
